module.exports = __webpack_public_path__ + "static/media/about.12fea42f.jpg";